export default "__VITE_ASSET__m_Ixa2it__"